import {AlertService} from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { QuestionSetLabel } from '../../shared/models/question-set-label';
import { QuestionSet } from '../../shared/models/question-set';

import { AssessmentService } from '../../shared/services/assessment.service';
import { Assessment } from '../../shared/models/assessment';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-label-new',
  templateUrl: './label-new.component.html',
  styleUrls: ['./label-new.component.css']
})
export class LabelNewComponent implements OnInit {

  private _label:QuestionSetLabel;
  private questionSet:QuestionSet;
  private assessment:Assessment;
  private readonly SAVE_TIME = 1500;
  private readonly ERROR_MESSAGE_TIME = 3000;
  public isSaving:boolean;

  constructor( private assessmentService:AssessmentService
    ,private alertService: AlertService
    ,private location:Location
    ,private router: Router
    ,private route: ActivatedRoute) { 
      this.label = this.getNewObject();
    }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let setId = params['setId'];
      this.assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this.assessment = assessment;
          this.questionSet = assessment.question_sets.find((s) => s.id == setId);
          if (!this.questionSet) {
            // TODO: stephen should we navigate back?? or do some kind of 404?
            this.router.navigate(["not-found"]);
          }
        })
        .catch((error) => {
          console.error(error);
          this.router.navigate(["not-found"]);
        })
    });
  }

  private getNewObject() {
    let label = new QuestionSetLabel();
    label.id = this.assessmentService.newId();
    return label;
  }

  get label():QuestionSetLabel {
    return this._label;
  }

  set label(v:QuestionSetLabel) {
    this._label = v;
  }

  goBack() {
    this.location.back();
  }

  private saveLabel(label) {
    this.questionSet.addLabel(label);
    this.isSaving = true;
		return this.assessmentService.saveAssessment(this.assessment).then((assessment) => {
      this.alertService.success("Label saved", this.SAVE_TIME);
      this.isSaving = false;
      return label;
    }).catch((error) => {
      this.isSaving = false;
      this.alertService.error("An error occurred in saving. Please try again or contact support.", this.ERROR_MESSAGE_TIME);
			console.error(error);
		});
  }

  save() {
    this.saveLabel(this.label).then((question) => {
      setTimeout(() => {
        this.router.navigate(["../", this.label.id, "edit"], {relativeTo: this.route, replaceUrl: true});
			}, this.SAVE_TIME);
    });
	}
	
	saveAndCreateNew() {
    this.saveLabel(this.label).then((question) => {
      this.label = this.getNewObject();
    });
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/label-new/label-new.component.ts